import {MetricType} from 'common/query-builder/query-block/constants';
import {ATTRIBUTION_OPTIONS, ATTRIBUTION_TYPE_TOOLTIPS} from 'common/report/funnels/models/constants';

import {isBehaviorShowClause} from '../models/utils';
import {ShowClause} from './types';

export function getFunnelAttributionItems(showClauses: ShowClause[]) {
  if (
    showClauses.length === 1 &&
    isBehaviorShowClause(showClauses[0]) &&
    showClauses[0].behavior.type === MetricType.Funnel
  ) {
    const {behaviors} = showClauses[0].behavior;
    const {actionMode, actionStep} = showClauses[0].measurement;
    const stepItems = behaviors.map((_, index) => ({
      label: `Step ${index + 1}`,
      value: index + 1,
      isSelected: false,
    }));
    const items = ATTRIBUTION_OPTIONS.concat(stepItems);

    let selectedIndex = items.map((item) => item.value, 10).indexOf(actionMode === `step` ? actionStep : actionMode);
    if (selectedIndex < 0) {
      selectedIndex = 0;
    }
    return items.map((item, index) => ({
      ...item,
      value: item.value,
      index: String(index),
      isSelected: index === selectedIndex,
      tooltip: ATTRIBUTION_TYPE_TOOLTIPS[item.value],
    }));
  }
  return null;
}
